import { MarkShape } from '@mui/x-charts/models';

import { COMPANY_SLOT, FARM_SHAPES, FIRST_FARM_SLOT, MARKET_SLOT } from 'views/benchmark-analytics/constants/benchmark-series';

// Company and market own the first two palette colors. Farms cycle through the rest and switch shape each time the colors run out.
export const seriesStyle = (slot: number, categorical: string[]): { color: string; shape: MarkShape } => {
  const colorAt = (index: number): string => categorical[index % categorical.length];

  if (slot === COMPANY_SLOT) return { color: colorAt(COMPANY_SLOT), shape: 'circle' };
  if (slot === MARKET_SLOT) return { color: colorAt(MARKET_SLOT), shape: 'square' };

  const farmColors = Math.max(categorical.length - FIRST_FARM_SLOT, 1);
  const farmIndex = slot - FIRST_FARM_SLOT;

  return {
    color: colorAt(FIRST_FARM_SLOT + (farmIndex % farmColors)),
    shape: FARM_SHAPES[Math.floor(farmIndex / farmColors) % FARM_SHAPES.length],
  };
};
